import { EntityUpgrades, UnitType, UpgradeStatus, UpgradeType } from '../../../types/game-types';

export const upgrades: Partial<EntityUpgrades> = {
  recruitWarriors: {
    id: UpgradeType.RecruitWarriors,
    icon: ['s_u_l_units0', 'warrior'],
    cost: { gold: 0 },
    costGrowthRate: 1,
    multiplier: 1, // Placeholder multiplier
    purchased: 1,
    bonusPerOwned: 1, // Placeholder bonus
    purchaseLimit: 1,
    isUnlocked: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  recruitWizards: {
    id: UpgradeType.RecruitWizards,
    icon: ['s_u_l_units0', 'wizard'],
    cost: { gold: 1000 },
    costGrowthRate: 1,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1, // Placeholder bonus
    purchaseLimit: 1,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  recruitElves: {
    id: UpgradeType.RecruitElves,
    icon: ['s_u_l_units0', 'elf'],
    cost: { gold: 2000 },
    costGrowthRate: 1,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1,
    purchaseLimit: 1,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  recruitThieves: {
    id: UpgradeType.RecruitThieves,
    icon: ['s_u_l_units0', 'thief'],
    cost: { gold: 3000 },
    costGrowthRate: 1,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1,
    purchaseLimit: 1,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  recruitBards: {
    id: UpgradeType.RecruitBards,
    icon: ['s_u_l_units0', 'bard'],
    cost: { gold: 3000 },
    costGrowthRate: 1,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1,
    purchaseLimit: 1,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  // recruitClerics: {
  //   id: UpgradeType.RecruitClerics,
  //   icon: ['s_u_l_units0', 'cleric'],
  //   cost: { gold: 10000 },
  //   costGrowthRate: 1,
  //   multiplier: 0,
  //   purchased: 0,
  //   bonusPerOwned: 1,
  //   purchaseLimit: 1,
  //   isUnlocked: false,
  //   type: UnitType.UPGRADE,
  //   tier: 'generators',
  //   status: UpgradeStatus.Unlocked,
  // },
  heroResources: {
    id: UpgradeType.HeroResources,
    icon: ['unitsDouble'],
    cost: { gold: 10000 },
    costGrowthRate: 1.5,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1, // Adds 1% critical chance per level
    purchaseLimit: 20,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  blessedAura: {
    id: UpgradeType.BlessedAura,
    icon: ['s_units1', 'bubbleEmpty'],
    cost: { gold: 5000 },
    costGrowthRate: 1.5,
    multiplier: 1, // Placeholder multiplier
    purchased: 0,
    bonusPerOwned: 0.1, // Placeholder bonus
    purchaseLimit: 10,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
};
